import { render, staticRenderFns } from "./chatbox.vue?vue&type=template&id=c624c956&scoped=true&"
import script from "./chatbox.vue?vue&type=script&lang=js&"
export * from "./chatbox.vue?vue&type=script&lang=js&"
import style0 from "./chatbox.vue?vue&type=style&index=0&id=c624c956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624c956",
  null
  
)

export default component.exports